/**
 * Native Authentication Configuration
 *
 * This replaces the Firebase authentication system.
 * Tokens are stored in localStorage and managed by the auth store.
 */

export const AUTH_CONFIG = {
  // Token storage keys
  ACCESS_TOKEN_KEY: 'access_token',
  REFRESH_TOKEN_KEY: 'refresh_token',

  // Token refresh threshold (refresh when token has less than 1 minute left)
  TOKEN_REFRESH_THRESHOLD: 60000, // 1 minute in milliseconds

  // Access token expiry (should match backend - 15 minutes)
  ACCESS_TOKEN_EXPIRY: 15 * 60 * 1000, // 15 minutes

  // Refresh token expiry (varies based on "remember me")
  REFRESH_TOKEN_SHORT_EXPIRY: 60 * 60 * 1000, // 1 hour
  REFRESH_TOKEN_LONG_EXPIRY: 7 * 24 * 60 * 60 * 1000, // 7 days
}

/**
 * Store access token in localStorage
 */
export function setAccessToken(token: string): void {
  localStorage.setItem(AUTH_CONFIG.ACCESS_TOKEN_KEY, token)
}

/**
 * Get access token from localStorage
 */
export function getAccessToken(): string | null {
  return localStorage.getItem(AUTH_CONFIG.ACCESS_TOKEN_KEY)
}

/**
 * Store refresh token in localStorage
 */
export function setRefreshToken(token: string): void {
  localStorage.setItem(AUTH_CONFIG.REFRESH_TOKEN_KEY, token)
}

/**
 * Get refresh token from localStorage
 */
export function getRefreshToken(): string | null {
  return localStorage.getItem(AUTH_CONFIG.REFRESH_TOKEN_KEY)
}

/**
 * Clear all auth tokens
 */
export function clearAuthTokens(): void {
  localStorage.removeItem(AUTH_CONFIG.ACCESS_TOKEN_KEY)
  localStorage.removeItem(AUTH_CONFIG.REFRESH_TOKEN_KEY)
}

/**
 * Check if user is authenticated (has access token)
 */
export function isAuthenticated(): boolean {
  return !!getAccessToken()
}
